// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAmNx_Q_ZiqqCZlPoy9ZleaJ5Ue8XRza0I",
  authDomain: "lcw2025.firebaseapp.com",
  databaseURL: "https://lcw2025-default-rtdb.firebaseio.com",
  projectId: "lcw2025",
  storageBucket: "lcw2025.firebasestorage.app",
  messagingSenderId: "658673781459",
  appId: "1:658673781459:web:ccfe14be3a01f282bae226",
  measurementId: "G-7L6GRJSN69"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
